import React, { Component } from 'react'
import { collection, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import db from '../firebase';
import { auth, provider, signInWithPopup, signOut } from '../firebase';
import { LoadProduction } from '../store/MetaStore';
import { Button, Card, CardBody, CardText, Carousel, Col, FormControl, InputGroup, Row } from 'react-bootstrap';
import { FaChartSimple, FaDisplay, FaGear, FaListCheck, FaMoneyCheckDollar, FaPaintbrush } from 'react-icons/fa6';
import CreateAppUser from './CreateAppUser';
import { FaSquareFacebook, FaWhatsapp } from 'react-icons/fa6';
import { FaMapMarkedAlt } from "react-icons/fa";
import BackgroundUploader from './Common/BackgroundUploader';
import FrameLandingpage from './Common/FrameLandinpage';


export default class LoadAppUser extends Component {
  constructor(props) {
    super(props)
    this.state = LoadProduction.init
    this.state.modalAlert = false
    this.handleConsole = this.handleConsole.bind(this)
  }

  cleanPathname() {
    const { pathname } = window.location;
    const decodedPathname = decodeURIComponent(pathname);
    return decodedPathname.startsWith('/')
      ? decodedPathname.substring('/'.length)
      : decodedPathname;
  }


  updateHeight = () => {
    this.setState({ viewportHeight: window.innerHeight });
  }



  toggleCheck = (checkId) => {
    this.setState((prevState) => ({
      selectedCheck: prevState.selectedCheck === checkId ? null : checkId,
      currentName: '',
      stateToggleCheck: checkId === 1 ? {} : prevState.stateToggleCheck,
    }), async () => {
      this.setState({
        metaObject: []
      })
    });
  }

  //this.addNewMessage()

  handleItemClick = (key) => {
    this.setState((prevState) => {
      const prevItem = prevState.itemsMap[key] || { clicks: 0, priceItem: 0 };
      const updatedItem = {
        ...prevItem,
        clicks: prevItem.clicks + 1,
        showCounter: true,
        totalPeerItem: (prevItem.clicks + 1) * prevItem.priceItem,
      };
      const updatedItemsMap = {
        ...prevState.itemsMap,
        [key]: updatedItem,
      };

      return {
        itemsMap: updatedItemsMap,
      };
    }, () => {
      const { itemsMap } = this.state;
      const selectedItems = Object.values(itemsMap).filter(item => item.clicks > 0);
      const totalCost = selectedItems.reduce((sum, item) => sum + (item.clicks * item.priceItem), 0);
      const totalItems = selectedItems.reduce((sum, item) => sum + item.clicks, 0);

      this.setState({
        totalCost,
        pointIconCheckout: {
          visible: totalItems > 0,
          totalItems,
        },
      });
    });
  };

  handleResetCounter = (key) => {
    this.setState((prevState) => {
      const updatedItemsMap = {
        ...prevState.itemsMap,
        [key]: {
          ...prevState.itemsMap[key],
          clicks: 0,
          showCounter: false,
          totalPeerItem: 0,
        },
      };
      return {
        itemsMap: updatedItemsMap,
      };
    }, () => {
      const { itemsMap } = this.state;
      const selectedItems = Object.values(itemsMap).filter(item => item.clicks > 0);
      const totalCost = selectedItems.reduce((sum, item) => sum + (item.clicks * item.priceItem), 0);
      const totalItems = selectedItems.reduce((sum, item) => sum + item.clicks, 0);

      this.setState({
        totalCost,
        pointIconCheckout: {
          visible: totalItems > 0,
          totalItems,
        },
      });
    });
  };


  restarTotalCost = (itemsMap) => {
    return Object.values(itemsMap).reduce((total, item) => {
      return total + item.priceItem * item.clicks;
    }, 0);
  };

  calculateTotalCost = (itemsMap) => {
    return Object.values(itemsMap).reduce((total, item) => {
      return total + (item.priceItem * item.clicks);
    }, 0);
  };


  async componentDidMount() {
    window.addEventListener('resize', this.updateHeight);
    this.updateHeight();
    const cleanedPathname = this.cleanPathname()
    const license = await doc(db, '$:__sites-name', cleanedPathname)
    if (cleanedPathname !== '') {
      const isLicenseAvalible = await getDoc(license)
      this.state = isLicenseAvalible.data()
      isLicenseAvalible.exists() ?
        this.setState({
          ...isLicenseAvalible.data(),
          pageExist: true
        }, () => {
          const favicon = document.getElementById('favicon');
          if (favicon) {
            favicon.href = this.state.setFavicon;
            this.applyHtmlBackground();
          } else {
            const newFavicon = document.createElement('link');
            newFavicon.id = 'favicon';
            newFavicon.rel = 'icon';
            newFavicon.href = this.state.setFavicon;
            document.head.appendChild(newFavicon);
          }
        })
        :
        setTimeout(() => {
          alert('este sitio no existe'); window.location = '/'
        }, 1500);
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateHeight);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.choiseColorBackground !== this.state.choiseColorBackground) {
      this.applyHtmlBackground();
    }
  }

  extractColorsFromGradient(gradientStr) {
    const regex = /linear-gradient\([^\)]+,\s*([^,]+),\s*([^)]+)\)/;
    console.log(gradientStr)

    const match = gradientStr.match(regex);
    if (match) {
      const color1 = match[1].trim();
      const color2 = match[2].trim();
      return { color1, color2 };
    }
    return null;
  }

  applyHtmlBackground = () => {
    const bg = this.state.choiseColorBackground;

    const colors = this.extractColorsFromGradient(bg.backgroundImage)
    if (bg.backgroundImage) {
      document.documentElement.style.backgroundImage = bg.backgroundImage;
      document.documentElement.style.backgroundColor = '';
      document.documentElement.style.background = colors.color1
    }

    if (bg.backgroundColor) {
      document.documentElement.style.backgroundColor = bg.backgroundColor;

    }
    document.documentElement.style.margin = '0';
    document.documentElement.style.padding = '0';
  }

  handleConsole() {
    this.setState({
      utaStep: true,
      frameOn: ''
    })
  }

  handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      this.setState({ user });
    } catch (error) {
      console.error('Error durante el inicio de sesión:', error);
    }
  };

  handleLogout = async () => {
    try {
      await signOut(auth);
      this.setState({ user: null });
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };


  renderContent = () => {
    const { contentMap } = this.state;

    return contentMap.map((content, index) => {
      switch (content.type) {
        case 'Encabezado':
          return (
            <div className={`animated ${content.style?.animation || ''}`} key={'encabezado-' + index}>
              <h2 id={'a' + index} style={content.style}>{content.title}</h2>
              <br />
            </div>
          )
        case 'Texto':
          return (<p key={'texto-' + index} style={content.style} >{content.text}</p>)
        case 'Imagen':
          return (<img key={'img-' + index} src={content.src} alt="Contenido" style={{ maxWidth: '100%' }} />);
        case 'Video':
          return (
            <video key={'video-' + index} controls style={{ maxWidth: '100%' }}>
              <source src={content.src} type="video/mp4" />
            </video>
          );
        case 'Carousel':
          return (
            <div key={'carousel-' + index} style={{ maxWidth: '100%' }}>
              <Carousel>
                {content.items.map((item, i) => (
                  <Carousel.Item key={i}>
                    <img
                      src={item.src}
                      alt={`Slide ${i}`}
                      style={{ width: '100%' }}
                    />
                    {item.caption && (
                      <Carousel.Caption>
                        <h3>{item.caption.title}</h3>
                        <p>{item.caption.text}</p>
                      </Carousel.Caption>
                    )}
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
          );

        case 'Grid':
          return (
            <div key={index} className="container">
              {content.rows.map((row, rowIndex) => (
                <div key={rowIndex} className="row">
                  {row.columns.map((col, colIndex) => (
                    <div key={colIndex} className={`col-${col.size || 12}`}>
                      {col.content}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          );
        case 'Marketplace':
          return (
            <div
              key={'marketplace-' + index}
              style={{
                justifyContent: 'center',
                display: 'flex',
                flexDirection: content.direction === 'horizontal' ? 'row' : 'column',
                gap: '15px',
                flexWrap: 'wrap',
                alignItems: 'center',
                padding: '10px',
              }}
            >
              {content.items.map((item, i) => {
                const itemState = this.state.itemsMap[item.key] || {};
                return (
                  <div
                    key={i}
                    style={{
                      border: '1px solid #ddd',
                      padding: '10px',
                      textAlign: 'center',
                      width: '150px',
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      boxShadow: '2px 2px 5px rgba(0,0,0,0.1)',
                      position: 'relative',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <div>
                      <img
                        src={item.src}
                        alt={item.name}
                        style={{
                          width: '100%',
                          height: '135px',
                          objectFit: 'fill',
                          borderRadius: '5px',
                        }}
                      />
                      <div className={`${item.enableFxFlame || ''} flame-container`}>
                        <svg className="flame" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                          <path fill="#FF5722" d="M32,4C32,4,2,24,8,46c3.889,14.11,24,18,24,18s20.111-3.89,24-18C62,24,32,4,32,4z" />
                          <path fill="#FF7043" d="M32,14c0,0-14.4,10.6-9.6,26.4C25.6,46.4,32,48,32,48s6.4-1.6,9.6-7.6C46.4,24.6,32,14,32,14z" />
                          <path fill="#FF8A65" d="M32,26c0,0-5.3,3.9-3.2,10.8C30.1,40.3,32,41,32,41s1.9-0.7,3.2-4.2C37.3,29.9,32,26,32,26z" />
                        </svg>
                      </div>
                      <p style={{ fontSize: '14px', margin: '5px 0', fontWeight: 'bold', height: '32px', overflow: 'hidden' }}>
                        {item.name}
                      </p>
                      <p style={{ fontSize: '13px', color: '#888', marginBottom: '5px' }}>${item.price}</p>
                      {itemState.clicks > 0 && (
                        <div style={{ fontSize: '13px', color: '#555' }}>
                          <strong>{itemState.clicks}</strong> seleccionados
                        </div>
                      )}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '10px' }}>
                      <button className="btn btn-sm btn-primary" onClick={() => this.handleItemClick(item.key)}>+</button>
                      {itemState.clicks > 0 && (
                        <button className="btn btn-sm btn-danger" onClick={() => this.handleResetCounter(item.key)}>Reset</button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        case 'DynamicNavbar':
          return (
            <div key={index} style={content.style} className="navbar-dynamic">
              <div style={{ display: 'flex', gap: '20px', position: 'relative' }}>
                {content.links.map((link, i) => (
                  <div
                    key={`link-${index}-${i}`}
                    style={{
                      position: 'absolute',
                      left: link.position.x,
                      top: link.position.y,
                      borderBottom: '1px solid #000',
                      padding: '5px 10px',
                      backgroundColor: '#fff',
                      cursor: 'pointer',
                    }}
                    onClick={() => this.handleSelectNavbarLink(index, i)}
                  >
                    {link.label}
                  </div>
                ))}
                <button
                  onClick={() => this.handleDeleteNavbar(index)}
                  style={{
                    position: 'absolute',
                    right: -15,
                    top: -15,
                    borderRadius: '50%',
                    backgroundColor: 'red',
                    color: 'white',
                    border: 'none',
                    width: 30,
                    height: 30,
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  X
                </button>
              </div>

              {this.renderDynamicNavbarContent(index)}
            </div>
          );

        default:
          return null;
      }
    });
  };

  generateNewSSCID = () => {
    const createSCID = () => {
      let seedKey = ['a', 'b', 'c', 'd', 'e', 'f', 'g', '0', '1', '2', '3', '4', '5', '6', '7', 'D', 'A', 'B', 'T'];
      let makeKey = '';
      seedKey.forEach(() => {
        let min = 0;
        let max = 18;
        let rand = (Math.random() * (max - min)) + min;
        makeKey += seedKey[Math.floor(rand)];
      });
      return { makeKey };
    };

    const newSSCID = createSCID().makeKey;
    this.setState({ sscid: newSSCID });
  };

  handleLoadFile = async (e) => {
    await this.generateNewSSCID();
    try {
      const { metaObject, itemsMap, siteName, txtTraker, sscid, totalCost } = this.state;
      const docRef = doc(db, '$:__site-tickets', sscid);
      const docSnap = await getDoc(docRef);
      const newTicket = {
        status: 'pendiente a pago',
        data: metaObject && Object.keys(metaObject).length > 0 ? metaObject : (itemsMap && Object.keys(itemsMap).length > 0 ? itemsMap : 'Sin datos disponibles'),
        nameId: txtTraker,
        idTicket: sscid,
        mptrue: e === 'stpay' ? false : true,
        totalCost: totalCost,
        securePayOn: false,
        maiBaikSecure: false,
        chatAndSoportUser: { user: [], provider: [] },
        chatAndSoportProvider: { user: [], provider: [] },
        imgSrcTracker: '',
      };

      if (!docSnap.exists()) {

        await setDoc(docRef, {
          pointMonitor: {
            ticketsNow: [newTicket],
          },
          createdDate: new Date().toLocaleString(),
          siteName: siteName,
        });
      } else {

        const dataFromFirestore = docSnap.data();
        this.setState({ pointMonitor: dataFromFirestore.pointMonitor }, async () => {
          this.setState(prevState => ({
            pointMonitor: {
              ...prevState.pointMonitor,
              ticketsNow: [...prevState.pointMonitor.ticketsNow, newTicket],
            }
          }), async () => {

            await updateDoc(docRef, { pointMonitor: this.state.pointMonitor });
          });
        });
      }

      if (e === 'stpay') {
        window.location = `/tickets/${siteName}/${sscid}/pendiente a pago`;
        const clearedItemsMap = { ...itemsMap };
        for (let key in clearedItemsMap) {
          clearedItemsMap[key] = {
            ...clearedItemsMap[key],
            clicks: 0,
            showCounter: false,
            totalPeerItem: 0,
          };
        }
        this.setState({
          itemsMap: clearedItemsMap,
          pointIconCheckout: {
            visible: false,
            totalItems: 0,
          },
          totalCost: 0,
        });
      } else if (this.mercadoPagoBtnRef.current) {
        this.mercadoPagoBtnRef.current.triggerPayment();
      }

    } catch (error) {

    }
  };

  render() {
    const { btnTxtTitle, choiseBtnColor, displayCharts, viewportHeight, choiseColorBackground } = this.state;

    return (
      <>
        <div className='App no-scroll' style={{ height: viewportHeight }}>
          <BackgroundUploader
            img1={this.state.isEnabledFull ? this.state.srcImgMapBackFull : this.state.defaultImages.full}
            img2={this.state.isEnabledSky ? this.state.srcImgMapBackSky : this.state.defaultImages.sky}
            img3={this.state.isEnabledCenter ? this.state.srcImgMapBackCenter : this.state.defaultImages.center}
            img4={this.state.isEnabledBase ? this.state.srcImgMapBackBase : this.state.defaultImages.base}
            choiseColorBackground={this.state.choiseColorBackground} />
          <div style={this.state.choiseColorBackground}>
            <div className={this.state.choiseStyleMain + ' ' + this.state.frameOn + ' p-fixed '}>
              {this.state.utaStep === false ?
                this.state.avalibleLoginMain === false ? <Button onClick={this.handleConsole} style={choiseBtnColor} className='z-modal' >{btnTxtTitle ? btnTxtTitle[6] : 'Loading...'}
                </Button> :
                  <div className='z-modal'>
                    {!this.state.user ? (
                      <div className='z-modal '>
                        <Button onClick={() => this.setState({ user: true })} style={choiseBtnColor} className='z-modal' >{btnTxtTitle ? btnTxtTitle[6] : 'Loading...'}
                        </Button>
                      </div>
                    ) : (
                      <div className='scroll-y display-wh' style={choiseColorBackground}>{this.renderContent()}</div>
                    )}
                  </div> : this.state.modalWelcome === true ? <CreateAppUser config={this.state} /> : <Card>
                    <CardBody>
                      <CardText>{this.state.txtModalWelcome}</CardText>
                    </CardBody>
                  </Card>}
            </div>
            <footer className='p-absolute bottom w-100 justify-center z-modal-con'>
              <Row className='  z-100 '>
                <Col>
                  {this.state.isValidUrl ? (
                    <div style={{ bottom: '0', color: 'blue', fontSize: '24px' }}>
                      <FaSquareFacebook className='c-pointer  z-100' onClick={() => { window.location = this.state.pointFaceUrl }} />
                    </div>
                  ) : (
                    null
                  )}
                </Col>
                <Col>
                  {this.state.isValidMap ? (
                    <div style={{ bottom: '0', fontSize: '24px', }}>
                      <svg width="25" height="25" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient id="googleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#4285F4" />
                            <stop offset="25%" stopColor="#EA4335" />
                            <stop offset="50%" stopColor="#FBBC05" />
                            <stop offset="75%" stopColor="#34A853" />
                            <stop offset="100%" stopColor="#EA4335" />
                          </linearGradient>
                        </defs>
                        <FaMapMarkedAlt fill="url(#googleGradient)" className='c-pointer z-100' onClick={() => { window.location = this.state.pointMapsUrl }} />
                      </svg>
                    </div>
                  ) : (
                    <></>
                  )}
                </Col>
                <Col>
                  {this.state.isValidWhats ? (
                    <div style={{ bottom: '0', fontSize: '24px', }}>
                      <svg width="25" height="25" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <linearGradient id="whatsGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#2FBC05" />
                            <stop offset="50%" stopColor="#34A853" />
                            <stop offset="75%" stopColor="#34A853" />
                            <stop offset="100%" stopColor="#414335" />
                          </linearGradient>
                        </defs>
                        <FaWhatsapp fill="url(#whatsGradient)" className='c-pointer z-100' onClick={() => { window.location = this.state.pointSeedWhatsUrl + this.state.pointWhatsUrl }} />
                      </svg>
                    </div>)
                    : (<>
                    </>)}
                </Col>
              </Row>
            </footer>
          </div>
        </div>
        {this.state.pointIconCheckout.visible && (
          <div
            onClick={() => this.setState({ showModalCheckout: true })}
            style={{
              position: 'fixed',
              bottom: '20px',
              right: '20px',
              backgroundColor: '#007bff',
              borderRadius: '50%',
              width: '60px',
              height: '60px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
              cursor: 'pointer',
              zIndex: 999999,
            }}
            title="Ver carrito"
          >
            🛒
            {this.state.pointIconCheckout.totalItems > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: '-5px',
                  right: '-5px',
                  backgroundColor: 'red',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontWeight: 'bold',
                }}
              >
                {this.state.pointIconCheckout.totalItems}
              </span>
            )}
          </div>
        )}
        {this.state.showModalCheckout && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99910000,
          }}>
            <div style={{
              backgroundColor: '#fff',
              padding: '20px',
              borderRadius: '10px',
              width: '90%',
              maxWidth: '500px',
              maxHeight: '90vh',
              overflowY: 'auto',
            }}>
              <h4>Artículos seleccionados</h4>
              <hr />
              {Object.entries(this.state.itemsMap)
                .filter(([, item]) => item.clicks > 0)
                .map(([key, item]) => (
                  <div key={key} style={{ marginBottom: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span><strong>{item.name}</strong> x {item.clicks}</span>
                      <span>${(item.priceItem * item.clicks).toFixed(2)}</span>
                    </div>
                  </div>
                ))}
              <hr />
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong>Total:</strong>
                <strong>${this.state.totalCost.toFixed(2)}</strong>
              </div>

              <div style={{ marginTop: '20px', textAlign: 'right' }}>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => this.setState({ showModalCheckout: false })}
                >
                  Cerrar
                </button>{' '}
                <button
                  className="btn btn-success btn-sm"
                  disabled={this.state.isSendingOrder}
                  onClick={async () => {
                    this.setState({ isSendingOrder: true });
                    await this.handleLoadFile('stpay');
                    this.setState({ showModalCheckout: false, isSendingOrder: false });
                  }}
                >
                  {this.state.isSendingOrder ? 'Enviando...' : 'Pagar / Enviar'}
                </button>
              </div>

            </div>
          </div>
        )}
      </>
    )
  }
}
